import { render, staticRenderFns } from "./IconComplete.vue?vue&type=template&id=13c7189f"
import script from "./IconComplete.vue?vue&type=script&lang=js"
export * from "./IconComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports